import { createSlice } from '@reduxjs/toolkit';

const uiSlice = createSlice({
  name: 'ui',
  initialState: {
    isMobile: window.innerWidth < 768,
    sidebarOpen: false,
    mobileMenuOpen: false,
    isFormDirty: false,
    confirmationModal: {
      isOpen: false,
      title: '',
      message: '',
      confirmId: null,
      type: 'default'
    },
    inactiveUserModalOpen: false,
    loading: {
      global: false,
      forms: false,
      submissions: false,
      sync: false
    },
    networkStatus: {
      isOnline: navigator.onLine,
      showOfflineIndicator: false,
      offlineIndicatorTimer: null
    }
  },
  reducers: {
    setIsMobile: (state, action) => {
      state.isMobile = action.payload;
    },
    toggleSidebar: (state) => {
      state.sidebarOpen = !state.sidebarOpen;
    },
    setSidebarOpen: (state, action) => {
      state.sidebarOpen = action.payload;
    },
    toggleMobileMenu: (state) => {
      state.mobileMenuOpen = !state.mobileMenuOpen;
    },
    setMobileMenuOpen: (state, action) => {
      state.mobileMenuOpen = action.payload;
    },
    setFormDirty: (state, action) => {
      state.isFormDirty = action.payload;
    },
    openConfirmationModal: (state, action) => {
      state.confirmationModal = {
        isOpen: true,
        title: action.payload.title,
        message: action.payload.message,
        confirmId: action.payload.confirmId,
        type: action.payload.type || 'default'
      };
    },
    closeConfirmationModal: (state) => {
      state.confirmationModal = {
        isOpen: false,
        title: '',
        message: '',
        confirmId: null,
        type: 'default'
      };
    },
    openInactiveUserModal: (state) => {
        state.inactiveUserModalOpen = true;
    },
    closeInactiveUserModal: (state) => {
        state.inactiveUserModalOpen = false;
    },
    setLoading: (state, action) => {
      const { type, loading } = action.payload;
      state.loading[type] = loading;
    },
    setNetworkStatus: (state, action) => {
      if (state.networkStatus.isOnline && !action.payload) {
        state.networkStatus.showOfflineIndicator = true;
      }
      state.networkStatus.isOnline = action.payload;
    },
    hideOfflineIndicator: (state) => {
      state.networkStatus.showOfflineIndicator = false;
    },
    setOfflineIndicatorTimer: (state, action) => {
      state.networkStatus.offlineIndicatorTimer = action.payload;
    }
  }
});

export const {
  setIsMobile,
  toggleSidebar,
  setSidebarOpen,
  toggleMobileMenu,
  setMobileMenuOpen,
  setFormDirty,
  openConfirmationModal,
  closeConfirmationModal,
  openInactiveUserModal,
  closeInactiveUserModal,
  setLoading,
  setNetworkStatus,
  hideOfflineIndicator,
  setOfflineIndicatorTimer
} = uiSlice.actions;

export default uiSlice.reducer;